var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _ellipse, _ellipse2, _ellipse3, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _ellipse4, _ellipse5, _path19, _path20, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _polygon6, _polygon7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "412px",
    height: "322.92px",
    viewBox: "0 0 412 322.92",
    style: {
      enableBackground: "new 0 0 412 322.92"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#000000;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st3{opacity:0.949;fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st4{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st5{opacity:0.949;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st6{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st7{fill:none;stroke:#000000;stroke-width:9;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st8{stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st9{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st10{fill:none;stroke:#000000;stroke-width:19;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st11{fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st12{clip-path:url(#SVGID_2_);}\r\n\t.st13{clip-path:url(#SVGID_4_);}\r\n\t.st14{clip-path:url(#SVGID_6_);fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st15{clip-path:url(#SVGID_8_);fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st16{clip-path:url(#SVGID_10_);fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st17{clip-path:url(#SVGID_12_);fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st18{opacity:0.9686;clip-path:url(#SVGID_14_);enable-background:new    ;}\r\n\t.st19{clip-path:url(#SVGID_16_);fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st20{opacity:0.9686;clip-path:url(#SVGID_18_);enable-background:new    ;}\r\n\t.st21{clip-path:url(#SVGID_20_);fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st22{clip-path:url(#SVGID_22_);fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st23{clip-path:url(#SVGID_24_);fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st24{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st25{clip-path:url(#SVGID_26_);}\r\n\t.st26{clip-path:url(#SVGID_28_);}\r\n\t.st27{clip-path:url(#SVGID_30_);fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st28{clip-path:url(#SVGID_32_);fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st29{clip-path:url(#SVGID_34_);fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st30{clip-path:url(#SVGID_36_);fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st31{opacity:0.9686;clip-path:url(#SVGID_38_);enable-background:new    ;}\r\n\t.st32{clip-path:url(#SVGID_40_);fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st33{opacity:0.9686;clip-path:url(#SVGID_42_);enable-background:new    ;}\r\n\t.st34{clip-path:url(#SVGID_44_);fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st35{clip-path:url(#SVGID_46_);fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st36{clip-path:url(#SVGID_48_);fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st37{opacity:0.0392;fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M14.91,26.06c0.42,21.5,0.41,43.01,1.41,64.48c0.75,16.21,0.44,32.35-0.77,48.51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M186.36,16.37c0.96,20.72,1.93,41.43,2.86,62.15c0.06,1.33-0.25,2.68-0.38,4.02"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M138.47,61c22.35,12.94,44.69,25.87,67.04,38.81"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M109.75,205.59c-16.3,13.89-32.61,27.79-48.91,41.68"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M109.09,203.99c15.92,11.76,31.83,23.51,47.75,35.27"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M109.09,146.27c1.27,19.75,0.25,39.55,0.58,59.32"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M54.12,34.17c-8.19,0-16.37,0-24.56,0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M54.12,43.32c-8.19,0-16.37,0-24.56,0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M109.97,203.99c-1.81,7.79-3.69,15.53-6.99,22.45"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M198.24,95.62c-1.99,1.53-1.67,3.43-0.59,5.11c2.4,3.73,5.08,7.29,10.08,8.58"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M212.38,97.41c-3.31-1.17-6.48-4.23-10.12-0.57"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st24",
    cx: 95.55,
    cy: 38.75,
    rx: 13.28,
    ry: 11.98
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st24",
    cx: 133.97,
    cy: 38.75,
    rx: 8.82,
    ry: 7.96
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st24",
    cx: 164.58,
    cy: 38.75,
    rx: 5.07,
    ry: 4.58
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "16.37,146.27 15.81,138.28 165.22,129.72 165.78,137.72 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "14.88,26.09 14.32,18.09 185.91,8.27 186.48,16.26 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "28.88,126.88 25.43,77.77 37.83,77.06 41.29,126.17 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "49.79,123.25 47.07,84.62 58.45,83.96 61.17,122.6 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "72.01,122.11 69.29,83.48 80.67,82.83 83.39,121.46 "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M279.68,286.82l0.57,7.59l7,2.74c0,0-8.01-4.78-14.72-2.15c-4.93,1.93-9.07,10.84-9.23,13.76 c-0.09,2.01,5.88,5.89,7.22,4.59c1.59-1.51,1-5.88,0.78-9.13c-0.35-5.19,5.94-6.23,5.94-6.23s-4.53,1.61-4.96,2.91 c-0.48,1.54-1.02,5.09-0.52,8.11c0.22,1.39,0.19,3.28,0.78,4.29c0.66,1.19,2.01,1.39,2.86,1.58c1.12,0.24,5.31,0.73,6.67-0.65 c1.18-1.23,0.63-3.22,1.06-5.06c0.73-3.07,1.94-5.94,1.94-5.94l-1.51,6.02c0,0-0.45,3.94,0.36,4.83c1.51,1.71,6.6,2.06,8.7,1.44 c2.96-0.89,8.93-3.83,10.56-6.54c1.2-1.99,2.63-7.15,1.58-9.3c-0.79-1.56-5.68-3.82-5.68-3.82l-0.02-3.89 c0,0.31-0.89,0.03-1.09,0.15c-0.58,0.37-2.86,0.17-2.86,0.17s-2.26-0.04-3.52-0.15c-1.26-0.11-2.98-0.61-4.32-1.09 C282.85,289.44,279.68,286.82,279.68,286.82z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M344.01,294.09l-3.03,6.96l-7.5,0.21c0,0,9.12-1.78,14.58,2.98c4.02,3.5,5,13.3,4.2,16.11 c-0.57,1.93-7.47,3.55-8.31,1.88c-1-1.97,0.98-5.88,2.25-8.87c2.03-4.78-3.56-7.89-3.56-7.89s3.74,3.06,3.73,4.43 c-0.05,1.61-0.7,5.14-2.16,7.83c-0.67,1.24-1.25,3.03-2.14,3.79c-1.02,0.9-2.35,0.63-3.22,0.51c-1.13-0.16-5.24-1.11-6.08-2.88 c-0.71-1.56,0.46-3.25,0.66-5.13c0.31-3.14,0.12-6.26,0.12-6.26l-0.55,6.18c0,0-0.87,3.87-1.92,4.43c-1.99,1.1-6.89-0.3-8.67-1.6 c-2.5-1.85-7.16-6.65-7.82-9.75c-0.48-2.28-0.14-7.64,1.56-9.31c1.25-1.2,6.6-1.68,6.6-1.68l1.58-4.26c-0.1,0.3,0.68,0.56,0.83,0.75 c0.43,0.55,1.27,0.45,2.5,1.49c0.83,0.7,2.14,0.73,3.36,1.05c1.22,0.33,2.35,0.94,3.77,0.94 C339.51,295.99,344.01,294.09,344.01,294.09z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M295.3,124.63c-34.83-6.23-37.97-2.25-64.16-22.05c-5.49-4.15-17.64-7.64-22.56-3.63 c-4.93,4,0.95,14.36,6.57,18.41c27.53,19.8,28.51,16.6,64.21,23.89c-1.16,14.68-3.36,30.26-5.56,45.84 c-0.3,2.16,1.94,4.48,4.76,4.93c17.55,2.77,35.11,5.54,52.66,8.31c6.18,0.98,12.09-3.81,10.54-8.54 c-4.33-13.3-5.44-27.05-3.23-40.29c22.62,13.02,33.46,21.02,30.13,41.51c-0.77,4.71,6.31,11.73,12.53,12.33 c6.22,0.6,11.16-4.56,11.05-9.36c-0.38-17.19-2.63-21.41-12.58-37.34s-29.83-29.69-52.15-30.79"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M311.92,132.31c-3.11-1.15-6.94,1.14-7.55,4.4c-0.61,3.26,1.97,6.71,5.25,7.2c3.28,0.49,6.68-1.91,7.48-5.12 c0.8-3.22-2.42-5.05-5.37-6.55"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M305.76,142.22c-2.35,6.91-3.25,14.31-2.85,21.64c1.61,1.87,3.23,3.74,4.84,5.61 c1.67-1.88,3.34-3.76,5.31-5.53c-0.23-6.52-0.45-13.05-0.68-19.57"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M341.49,198.02c3.13,29.71,7.94,56.03,11.06,85.74c0.63,5.99-8.21,12.6-17.88,11.85 c-9.67-0.76-17.32-8.1-16.63-13.99c3.08-26.11-1-48.26-10.29-74.76c0.98,25.22,1.96,50.44,2.94,75.66 c0.22,5.69-8.02,10.34-17.23,9.71c-9.21-0.62-17.7-6.39-17.75-12.07c-0.26-29.58-0.51-59.15-0.77-88.73"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M390.6,202.12c3.29,5.13,5.72,10.69,7.19,16.46c0.22,0.87-0.41,1.86-1.39,2.16s-2.15-0.14-2.57-0.95 c-1.94-3.78-3.88-7.56-5.81-11.34c1.73,3.7,3.47,7.41,5.2,11.11c0.43,0.92-0.42,2.05-1.53,2.3c-1.11,0.26-2.29-0.2-3.07-0.92 c-0.77-0.72-1.21-1.67-1.58-2.6c-1.34-3.4-2.68-6.79-4.02-10.19c1.53,3.77,3.06,7.55,4.59,11.32c0.33,0.82-0.22,1.85-1.16,2.16 c-0.94,0.31-2.11-0.15-2.46-0.96c-1.74-4.12-3.49-8.24-5.23-12.36c-1.42,0.86-2.88,1.73-4.56,2.06s-3.63-0.04-4.58-1.26 s-0.31-3.3,1.36-3.62c2.17-0.42,4.35-0.84,6.52-1.26"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6825 -0.7309 0.7309 0.6825 30.9646 239.2015)",
    className: "st24",
    cx: 290.82,
    cy: 83.96,
    rx: 17.8,
    ry: 18.2
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6825 -0.7308 0.7308 0.6825 43.1677 272.1604)",
    className: "st24",
    cx: 334.86,
    cy: 86.39,
    rx: 17.8,
    ry: 18.2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M308.8,85.72c0.2-1.58,2.07-2.84,4.07-2.75c2,0.1,3.82,1.53,3.95,3.12"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M326.51,106.02c-8.53-3.13-18.93-3.73-28.63-2c1.78,6.57,7.59,11.6,13.76,11.94 c6.18,0.34,12.29-4.02,14.5-10.38"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_25_",
    points: "270.99,38.47 359.44,43.36 356.53,131.18 268.09,126.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_27_",
    points: "270.99,38.47 359.44,43.36 356.53,131.18 268.09,126.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_29_",
    points: "270.99,38.47 359.44,43.36 356.53,131.18 268.09,126.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_29_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M334.04,117.64 c-5.16,2.76-14.81,4.61-23.39,4.13"
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_31_",
    points: "270.99,38.47 359.44,43.36 356.53,131.18 268.09,126.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_31_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_8_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M336.11,116.39 c-0.45,0.34-2.11,1.27-2.11,1.27L336.11,116.39z"
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_33_",
    points: "270.99,38.47 359.44,43.36 356.53,131.18 268.09,126.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_33_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_10_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M343.5,71.03 c9.79,6.27,9.21,13.75,9.05,18.58c-0.4,12.16-10.09,21.99-16.46,26.79"
  })), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_35_",
    points: "270.99,38.47 359.44,43.36 356.53,131.18 268.09,126.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_35_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_12_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M310.75,121.79 c-22.12-1.22-41.21-17.83-38.89-36.58c0.65-5.26,0.7-12.61,11.22-17.91"
  })), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_37_",
    points: "270.99,38.47 359.44,43.36 356.53,131.18 268.09,126.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_37_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_39_",
    points: "277.65,45.54 296.46,46.58 295.74,68.37 276.93,67.33  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_39_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_16_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M295.83,55.2 c-3.45-3.38-7.18-6.18-11.62-8.17c-1.55-0.74-3.34-1.27-4.73-0.26c-0.69,0.62-1.4,1.44-1.43,2.3 c-0.4,5.18,0.08,9.34,2.17,14.01c0.85,1.56,1.89,4.07,3.09,4.14"
  }))))), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_41_",
    points: "270.99,38.47 359.44,43.36 356.53,131.18 268.09,126.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_41_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_43_",
    points: "330.64,47.29 354.87,48.62 354.09,72.03 329.86,70.69  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_43_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_20_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M343.01,71 c3.01-1.34,7.11-2.84,7.91-6.17c-1.93,0.34-3.22,0.3-5.16,0.57c3.24-1.76,6.09-4.27,7.83-7.47 c-1.57,0.5-3.07,1.16-4.63,1.67c1.41-3.14,2.44-6.98,0.29-10.14c-1.09-1.15-2.68-0.8-4.04-0.44 c-5.48,2.3-10.11,5.94-14.61,9.59"
  }))))), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_45_",
    points: "270.99,38.47 359.44,43.36 356.53,131.18 268.09,126.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_45_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_22_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M332.52,57.05 c-0.67,0.39-0.97,1.3-1.72,1.54c-0.32,0.1-0.67,0.06-1-0.01c-3.09-0.57-5.77-2.44-8.43-4.09c-2.67-1.65-5.68-3.18-8.62-2.62 c3.63,0.91,6.85,3.33,8.44,6.59c-3.36-2.34-7.45-3.61-11.54-4.02c-4.09-0.41-7.5,0.24-11.51,1.03 c-0.87,0.17-1.96,0.29-2.49-0.42"
  })), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_47_",
    points: "270.99,38.47 359.44,43.36 356.53,131.18 268.09,126.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_47_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_24_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M346.38,53.93 c2.71-0.97-1.71,0.45-2.73,1.72c-1.2,1.47-5.38,5.57-5.77,7.43c-0.11,0.52-0.21,1.06-0.51,1.51 c-0.65,0.96-2.03,1.11-3.22,1.11c-4.36-0.04-8.66-1.17-13.03-1.36c-0.91-0.04-1.88-0.03-2.65,0.41 c-1.27,0.72-1.81,2.46-3.26,2.77c-1.59,0.34-2.88-1.21-4.04-2.34c-1.83-1.78-4.31-2.86-6.85-3.31 c-2.54-0.46-5.14-0.31-7.68,0.07c-1.42,0.21-2.86,0.51-4.31,0.32c-0.33-0.04-0.68-0.12-0.93-0.33 c-0.29-0.24-0.4-0.59-0.51-0.94c-0.94-2.91-2.35-5.68-4.17-8.19c-0.46-0.62-2.34-2.09-3.08-2.33 c-2.3-0.71,2.72,0.92,3.02,2.33"
  })))))))), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "327.5,128.07 313.49,128.8 324.18,141.69 "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "296.03,125 309.59,128.58 296.49,139.02 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResults);
export default __webpack_public_path__ + "static/media/results.4d246b1feddf5060b871c0a282361d2f.svg";
export { ForwardRef as ReactComponent };